import { getCurrentDate } from "../features/utils/commonFunctions";

export type Action =
  | { __tag: "web"; value: LinkAction }
  | { __tag: "flow"; value: FlowLinkAction }
  | { __tag: "email"; value: MailLinkAction }
  | { __tag: "screen"; value: ScreenLinkAction }
  | { __tag: "gallery"; value: GalleryLinkAction };

export type RawAction =
  | LinkAction
  | FlowLinkAction
  | MailLinkAction
  | ScreenLinkAction
  | GalleryLinkAction;

export default Action;
export class LinkAction {
  action_type: string;
  created: string;
  updated: string;
  weblink: string;

  constructor(weblink: string) {
    this.action_type = "MMActionTypeWebLink";
    this.created = getCurrentDate();
    this.updated = getCurrentDate();
    this.weblink = weblink;
  }

  static fromJSON(json: any): LinkAction {
    let actionObj = Object.create(LinkAction.prototype);
    Object.assign(actionObj, json, {});
    return actionObj;
  }
}

export class FlowLinkAction {
  action_type: string;
  created: string;
  updated: string;
  weblink: string;
  __stringId: string;
  __index: number;
  constructor(stringId: string, index: number) {
    this.action_type = "MMActionTypeWebLink";
    this.created = getCurrentDate();
    this.updated = getCurrentDate();
    this.weblink = `flowLink://stringID=${stringId}&screenIndex=${index}`;
    this.__stringId = stringId;
    this.__index = index;
  }

  static fromJSON(json: any): FlowLinkAction {
    let actionObj = Object.create(this.prototype);
    let stringId = /stringID.*&/.exec(json.weblink)![0];
    stringId = stringId.replace("stringID=", "");
    stringId = stringId.substring(0, stringId.length - 1);
    let screenNum = /screenIndex\=.*$/.exec(json.weblink)![0];
    screenNum = screenNum.replace("screenIndex=", "");
    Object.assign(actionObj, json, {
      __stringId: stringId,
      __index: screenNum,
    });
    return actionObj;
  }
}

export class MailLinkAction {
  action_type: string;
  created: string;
  updated: string;
  weblink: string;
  __email: string;

  constructor(email: string) {
    this.action_type = "MMActionTypeWebLink";
    this.created = getCurrentDate();
    this.updated = getCurrentDate();
    this.weblink = `mailto:${email}`;
    this.__email = email;
  }

  static fromJSON(json: any): MailLinkAction {
    let actionObj = Object.create(MailLinkAction.prototype);
    Object.assign(actionObj, json, {
      __email: json.weblink.replace("mailto:", ""),
    });
    return actionObj;
  }
}

export class ScreenLinkAction {
  action_type: string;
  created: string;
  updated: string;
  ScreenLinkTransition: string;
  screenID: string;
  constructor(screenLinkTransition: string, screenId: string) {
    this.action_type = "MMActionScreenLink";
    this.created = getCurrentDate();
    this.updated = getCurrentDate();
    this.ScreenLinkTransition = screenLinkTransition;
    this.screenID = screenId;
  }

  static fromJSON(json: any): ScreenLinkAction {
    let actionObj = Object.create(ScreenLinkAction.prototype);
    Object.assign(actionObj, json, {});
    return actionObj;
  }
}

/**
 * skips any key prefixed with "__"
 * skips any key/value where value has a key `__tag` and uses `value.value`.
 *  - ignores the implementation detail of storing as a discriminant union `{__tag: "", value: T}`.
 *
 * Intended for use with JSON.stringify
 */
export function replacer(key: any, value: any) {
  if (key.startsWith("__")) return undefined;
  if (value && value.__tag) return value.value;
  return value;
}
export class GalleryLinkAction {
  action_type: string;
  created: string;
  updated: string;
  constructor() {
    this.action_type = "galleryLink";
    this.created = getCurrentDate();
    this.updated = getCurrentDate();
  }

  static fromJSON(json: any): GalleryLinkAction {
    let actionObj = Object.create(this.prototype);
    Object.assign(actionObj, json, {});
    return actionObj;
  }
}
